import React, { useEffect } from 'react';
import {
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    TableContainer
} from "@mui/material";
import { TableWrapper } from "../../../../globalstyles";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { TitleContainer } from "../styles";

const RecentOrders = ({ t }) => {
    const lang = useSelector((state) => state.App.lang);
    const courseState = useSelector((state) => state.PrivateCourse);
    const { myCoursesListLoading, myCoursesList } = courseState;

    return (
        <TableWrapper lang={lang}>
            <TitleContainer>{t("recent orders")}</TitleContainer>
            <TableContainer >
                <Table >
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">{t("price")}</TableCell>
                            <TableCell align="center">{t("start date")}</TableCell>
                            <TableCell align="center">{t("Number of sessions")}</TableCell>
                            <TableCell align="center">{t("course title")}</TableCell>
                            <TableCell align="center">{t("Number of orders")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            myCoursesListLoading !== true ? myCoursesList.length > 0 ?
                                myCoursesList.map((row, ind) => {
                                    return(
                                    <TableRow key={ind}>
                                        <TableCell align="center">{row.course.price}</TableCell>
                                        <TableCell align="center">{lang === "fa" ? row.course.start_date_fa : row.course.start_date_en}</TableCell>
                                        <TableCell align="center">{row.course.sessions}</TableCell>
                                        <TableCell align="center">{lang === "fa" ? row.course.fa_title : row.course.en_title}</TableCell>
                                        <TableCell align="center">{row.course.price}</TableCell>
                                    </TableRow>)
                                })
                                : <>{t("no data to dispaly")}</>
                                : <div className="loader"></div>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </TableWrapper>
    )
}
export default withTranslation()(RecentOrders);